import React from 'react'
import styled from 'styled-components'
import o1 from '../Events/Photos/o1.jpg'
import o2 from '../Events/Photos/o2.jpg'
import o3 from '../Events/Photos/o3.jpg'
import o4 from '../Events/Photos/o4.jpg'
import o5 from '../Events/Photos/o5.jpg'
import o6 from '../Events/Photos/o6.jpg'
import o7 from '../Events/Photos/o7.jpg'
import o8 from '../Events/Photos/o8.jpg'
import k3 from '../Events/Photos/k3.jpg'
import k4 from '../Events/Photos/k4.jpg'
import k5 from '../Events/Photos/k5.jpg'
import lc1 from '../Events/Photos/lc1.jpg'
import lc2 from '../Events/Photos/lc2.jpg'
import lc3 from '../Events/Photos/lc3.jpg'


export default function Events() {
    return (
        <>
        <Gallery>
          <Image src={k5} alt="photo9" /> 
          <Image src={k3} alt="photo13" /> 
          <Image src={k4} alt="photo8" /> 
          <Image src={lc1} alt="photo10" /> 
          <Image src={lc2} alt="photo11" /> 
          <Image src={lc3} alt="photo12" /> 
          <Image src={o1} alt="photo1" /> 
          <Image src={o2} alt="photo2" /> 
          <Image src={o3} alt="photo3" /> 
          <Image src={o4} alt="photo5" />
          <Image src={o5} alt="photo6" /> 
          <Image src={o6} alt="photo7" /> 
          <Image src={o8} alt="optic8" /> 
          <Image src={o7} alt="photo8" />
        </Gallery> 
        </>
    )
}
;

const Gallery = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content:center;
`;

const Image = styled.img`
  width: 100%;
  max-width:500px;
  height: auto;
  margin: 10px;
  object-fit: cover;
`;